import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../Services/UserService';
import { Userclass } from '../Classes/Userclass';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'User-Manage',
  templateUrl: '../Users/User.Component.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css','../../Content/css/fixedheader.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [UserService]
})

export class UserComponent implements OnInit {
  _user = new Userclass();
  GetUserDetails: any = [];
  innerWidth: number;
  GetUserRoles: any = [];
  Loaderimage: string = '../../assets/images/ajax-loader3.gif';
  loading: boolean = false;
  UserAdd: string = "none";

  PermissionRole: string;
  TitleName: string;
  UserStatus: any[] = [
    { Value: 'Active', Text: 'Active' },
    { Value: 'Inactive', Text: 'Inactive' }
  ]
  isValidFormSubmitted = false;
  constructor(private route: ActivatedRoute, private router: Router, private _userservice: UserService,
    public toastr: ToastsManager, vcr: ViewContainerRef)
  {
    this.toastr.setRootViewContainerRef(vcr);
    this.innerWidth=100;
  }

  ngOnInit() {
    this.ChangeHeadeFooterColor();
    this.GetAllUserdetails();
    this.GetAllRoles();
  }

  
  GetAllUserdetails() {
    this.loading = true;
    this._userservice.GetAllUserdetails().subscribe(res => {
      var data = res;
      this.GetUserDetails = data;
      this.loading = false;
    })
  }

  get_url: string = '';
  public ChangeHeadeFooterColor() {

    this.get_url = window.location.origin;
    if (this.get_url == "https://localhost:44335") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

      // var mnu_Reports = document.getElementsByTagName("ul[_ngcontent-c2] li[_ngcontent-c2]");


    }
    else if (this.get_url == "https://inn-flowmgt-test.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#cc4141";

      var footer = document.getElementById("footer");
      footer.style.background = "#cc4141";

      var header = document.getElementById("header");
      header.style.background = "#cc4141";

    }
    else if (this.get_url == "https://inn-flowmgt-staging.azurewebsites.net") {
      var a = document.getElementById("mainbox");
      a.style.backgroundColor = "#ed7d31";

      var footer = document.getElementById("footer");
      footer.style.background = "#ed7d31";

      var header = document.getElementById("header");
      header.style.background = "#ed7d31";
    }
  }

  GetAllRoles() {
    this._userservice.GetAllRoles().subscribe(res => {
      var data = res;
      this.GetUserRoles = data;
    })
  }

  SaveUserDetails(form: NgForm) {
    this._user.BCCEmail = sessionStorage.getItem('BCCEmail');
    this._user.FirstName = this._user.FirstName.trim();
    this._user.FirstName = this._user.FirstName.charAt(0).toUpperCase() + this._user.FirstName.slice(1).toLowerCase();
    this._user.LastName = this._user.LastName.trim();
    this._user.LastName = this._user.LastName.charAt(0).toUpperCase() + this._user.LastName.slice(1).toLowerCase();
    var LnameLength = this._user.LastName.length;
    var LastChar = this._user.LastName.substring(LnameLength - 1, LnameLength)

    if (this.isInteger(LastChar)) {
      this.toastr.error('Please enter the valid Last Name.');
      return;
    }
    this._user.Email = this._user.Email.trim();
    this._user.UserName = "";
    this.loading = true;
    this._userservice.SaveUserDetails(this._user).subscribe(res => {
      var data = res;
      if (!data.Message) {
        this.toastr.success(data[0].message);
        this.UserAdd = "none";
        this.GetAllUserdetails();
        this.loading = false;
        form.reset();
      }
      else {
        this.toastr.error(data.Message);
        this.loading = false;
      }
    })
  }

  EditUserInfo(Userdetails: any) {
    this._user.Useruniqueno = Userdetails.Useruniqueno;
    this._user.FirstName = Userdetails.Firstname;
    this._user.LastName = Userdetails.LastName;
    this._user.UserName = Userdetails.Username;
    this._user.Email = Userdetails.Email;
    this._user.Status = Userdetails.Status;
    this._user.RoleID = Userdetails.RoleID;
    this.PermissionRole = Userdetails.RoleID;
    this._user.Type = "Update";
    this.UserAdd = "block";
    this.TitleName = Userdetails.Username;
  }

  AddNew() {
    this._user.FirstName = null;
    this._user.LastName = null;
    this._user.UserName = null;
    this._user.Email = null;
    this._user.Status = this.UserStatus[0].Value;
    this._user.RoleID = null;
    this._user.Useruniqueno = null;
    this.PermissionRole = null;
    this._user.Type = "Add";
    this.UserAdd = "block";
    this.TitleName = "Create New User";
  }


  HidePwdPopUp(form: NgForm) {
    this.UserAdd = "none";
    form.reset();
  }

  isInteger(value) {
  if (value.indexOf('.') != -1) {
    return false;
  }
  if ((undefined === value) || (null === value)) {
    return false;
  }
  return value % 1 == 0;
  }

  TrimEmail(Email: string) {
    this._user.Email = Email.trim();
    return this._user.Email;
  }

  //CombineFirstLastname(FirstName: string, Lastname: string) {
  //  return FirstName.trim().charAt(0).toLocaleUpperCase() + FirstName.slice(1).toLocaleLowerCase()
  //    + '.' + Lastname.trim().charAt(0).toLocaleUpperCase() + Lastname.slice(1).toLocaleLowerCase();
  //}


}



// WEBPACK FOOTER //
// ./src/app/Users/UsersComponent.ts